
<ng-container *ngIf="isDataExist; then showBankDetails else emptyBankDetailsTable"></ng-container>

<ng-template #showBankDetails>
  <!---------------------------->
  <!-- Content Fields Details:-->
  <!---------------------------->
  <div *ngIf="application?.membership" class="clearfix mt2 mb2">
    <div class="md-col md-col-6">
      <div class="flex flex-column">
        <div class="col-12">
          <app-content-field [content]="application?.membership?.taxNumber"
                            [label]="'Principal Tax Number'">
          </app-content-field>
        </div>
      </div>
    </div>
  </div>

  <!---------------------------->
  <!-- Bank Details:-->
  <!---------------------------->

  <ng-container>
    <table [dataSource]="bankDetails" class="mat-elevation-z8" mat-table>
      <ng-container [matColumnDef]="tableColumns.Usage">
        <th *matHeaderCellDef mat-header-cell> Usage</th>
        <td *matCellDef="let bankDetail" mat-cell> {{bankDetail[tableColumns.Usage]}} </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.BankCode">
        <th *matHeaderCellDef mat-header-cell> Bank Code</th>
        <td *matCellDef="let bankDetail" mat-cell> {{bankDetail[tableColumns.BankCode]}} </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.BankAccountType">
        <th *matHeaderCellDef mat-header-cell> Account Type</th>
        <td *matCellDef="let bankDetail" mat-cell> {{bankDetail[tableColumns.BankAccountType]}} </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.BranchCode">
        <th *matHeaderCellDef mat-header-cell> Branch Code</th>
        <td *matCellDef="let bankDetail" mat-cell> {{bankDetail[tableColumns.BranchCode]}} </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.AccountNumber">
        <th *matHeaderCellDef mat-header-cell> Account Number</th>
        <td *matCellDef="let bankDetail" mat-cell> {{bankDetail[tableColumns.AccountNumber]}} </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.AccountName">
        <th *matHeaderCellDef mat-header-cell> Account Name</th>
        <td *matCellDef="let bankDetail" mat-cell> {{bankDetail[tableColumns.AccountName]}} </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.DebitOrderDay">
        <th *matHeaderCellDef mat-header-cell> Debit Order Day</th>
        <td *matCellDef="let bankDetail" mat-cell> {{bankDetail[tableColumns.DebitOrderDay]}} </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.IsThirdPartyAccount">
        <th *matHeaderCellDef mat-header-cell> is 3<sup><small>rd</small></sup> Party Account</th>
        <td *matCellDef="let bankDetail" mat-cell>
          {{bankDetail[tableColumns.IsThirdPartyAccount] ? 'Yes' : 'No'}}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.IsVerified">
        <th *matHeaderCellDef mat-header-cell> Is Verified</th>
        <td *matCellDef="let bankDetail" mat-cell>
          <greydom-status-indicator
            [fillColor]="getStatusColor(bankDetail[tableColumns.IsVerified])"></greydom-status-indicator>
          {{getVerificationStatus(bankDetail[tableColumns.IsVerified])}}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Actions">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let bankDetail" mat-cell>
            <span [matTooltip]="editTooltip()">
              <button mat-icon-button
                      [disabled]="isProcessing || !hasPermissions || isApplicationLocked"
                      [class.disabled]="!hasPermissions || isApplicationLocked"
                      (click)="onEditBankDetails(bankDetail)">
                <mat-icon class="table-icon">edit</mat-icon>
              </button>
            </span>
          <app-busy-spinner-icon *ngIf="isProcessing"></app-busy-spinner-icon>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>
  </ng-container>
</ng-template>

<ng-template #emptyBankDetailsTable>
  <div class="text-center">
    <label class="column-label">No bank accounts specified</label>
  </div>
</ng-template>
